import { RouteConfig } from 'vue-router';
const Folder = () => import('./views/folder.vue');
const Search = () => import('./views/search.vue');
const routers: RouteConfig[] = [
    {
        path: 'folder',
        component: Folder,
    },
    {
        path: 'search',
        component: Search,
    },
    {
        path: '*',
        redirect: 'folder'
    },
];
export default routers;

